/* eslint-disable no-irregular-whitespace */
import React, { ReactNode } from 'react'
import Aiven from '../../assets/images/customers/white/aiven.svg'
import AivenCompact from '../../assets/images/customers/compact-white/AivenCompact.svg'
import Alven from '../../assets/images/partner-logos-white/Alven.svg'
import Antler from '../../assets/images/partner-logos-white/Antler.svg'
import Bolt from '../../assets/images/customers/white/bolt.svg'
import BoltCompact from '../../assets/images/customers/compact-white/BoltCompact.svg'
import Box from '../primitives/Box'
import byFounders from '../../assets/images/partner-logos-white/byFounders.svg'
import CapitalOne from '../../assets/images/customers/white/capital-one.svg'
import Choco from '../../assets/images/customers/white/choco.svg'
import ChocoCompact from '../../assets/images/customers/compact-white/ChocoCompact.svg'
import DigVentures from '../../assets/images/partner-logos-white/DigVentures.svg'
import Dotwork from '../../assets/images/customers/white/dotwork.svg'
import GoogleCloud from '../../assets/images/customers/white/google-cloud.svg'
import Gorgias from '../../assets/images/customers/white/gorgias.svg'
import Honeycomb from '../../assets/images/customers/white/honeycomb.svg'
import Hostaway from '../../assets/images/customers/white/hostaway.svg'
import GorgiasCompact from '../../assets/images/customers/compact-white/GorgiasCompact.svg'
import HoneycombCompact from '../../assets/images/customers/compact-white/HoneycombCompact.svg'
import Illusian from '../../assets/images/partner-logos-white/Illusian.svg'
import Lovable from '../../assets/images/customers/white/lovable.svg'
import Matillion from '../../assets/images/customers/white/matillion.svg'
import Miro from '../../assets/images/customers/white/miro.svg'
import MiroCompact from '../../assets/images/customers/compact-white/MiroCompact.svg'
import MoltenVentures from '../../assets/images/partner-logos-white/MoltenVentures.svg'
import n8n from '../../assets/images/customers/white/n8n.svg'
import NAP from '../../assets/images/partner-logos-white/NAP.svg'
import NEA from '../../assets/images/partner-logos-white/NEA.svg'
import { overviewMinusMargin } from './OverviewBlock'
import Pleo from '../../assets/images/customers/white/pleo.svg'
import PleoCompact from '../../assets/images/customers/compact-white/PleoCompact.svg'
import Row from '../primitives/Row'
import Stack from '../primitives/Stack'
import Superhuman from '../../assets/images/customers/white/superhuman.svg'
import SuperhumanCompact from '../../assets/images/customers/compact-white/SuperhumanCompact.svg'
import Truelayer from '../../assets/images/customers/white/truelayer.svg'
import TruelayerCompact from '../../assets/images/customers/compact-white/TruelayerCompact.svg'
import Trustpilot from '../../assets/images/customers/white/trustpilot.svg'
import Verdane from '../../assets/images/partner-logos-white/Verdane.svg'
import Webflow from '../../assets/images/customers/white/webflow.svg'
import WebflowCompact from '../../assets/images/customers/compact-white/WebflowCompact.svg'
import YCombinator from '../../assets/images/partner-logos-white/YCombinator.svg'

type Logo = {
  src: string
  alt: string
}

type LogoRow = Logo[]

type LogoRowGroup = LogoRow[]

type Logos = LogoRowGroup[]

const logoSets = {
  all: [
    [
      [
        { src: Miro, alt: 'Miro' },
        { src: Bolt, alt: 'Bolt' },
        { src: Webflow, alt: 'Webflow' },
      ],
      [
        { src: Superhuman, alt: 'Superhuman' },
        { src: Pleo, alt: 'Pleo' },
        { src: Matillion, alt: 'Matillion' },
      ],
    ],
    [
      [
        { src: Lovable, alt: 'Lovable' },
        { src: Truelayer, alt: 'TrueLayer' },
        { src: Aiven, alt: 'Aiven' },
      ],
      [
        { src: Gorgias, alt: 'Gorgias' },
        { src: Trustpilot, alt: 'Trustpilot' },
        { src: Choco, alt: 'Choco' },
      ],
    ],
  ],
  compact: [
    [
      [
        { src: MiroCompact, alt: 'Miro' },
        { src: BoltCompact, alt: 'Bolt' },
        { src: PleoCompact, alt: 'Pleo' },
        { src: TruelayerCompact, alt: 'TrueLayer' },
      ],
    ],
    [
      [
        { src: WebflowCompact, alt: 'Webflow' },
        { src: AivenCompact, alt: 'Aiven' },
        { src: ChocoCompact, alt: 'Choco' },
        { src: SuperhumanCompact, alt: 'Superhuman' },
      ],
    ],
  ],
  partnerprogram: [
    [
      [
        { src: Lovable, alt: 'Lovable' },
        { src: Miro, alt: 'Miro' },
        { src: Bolt, alt: 'Bolt' },
        { src: Pleo, alt: 'Pleo' },
        { src: Truelayer, alt: 'TrueLayer' },
      ],
    ],
    [
      [
        { src: Webflow, alt: 'Webflow' },
        { src: Aiven, alt: 'Aiven' },
        { src: Trustpilot, alt: 'Trustpilot' },
        { src: Choco, alt: 'Choco' },
        { src: Superhuman, alt: 'Superhuman' },
      ],
    ],
  ],
  startups: [
    [
      [
        { src: Lovable, alt: 'Lovable' },
        { src: n8n, alt: 'n8n' },
        { src: Superhuman, alt: 'Superhuman' },
        { src: Hostaway, alt: 'Hostaway' },
        { src: Pleo, alt: 'Pleo' },
        { src: Honeycomb, alt: 'Honeycomb' },
        { src: Truelayer, alt: 'TrueLayer' },
      ],
    ],
  ],
  partners: [
    [
      [
        { src: YCombinator, alt: 'YCombinator' },
        { src: NEA, alt: 'NEA' },
        { src: byFounders, alt: 'byFounders' },
        { src: Antler, alt: 'Antler' },
        { src: NAP, alt: 'NAP' },
      ],
    ],
    [
      [
        { src: Alven, alt: 'Alven' },
        { src: MoltenVentures, alt: 'MoltenVentures' },
        { src: DigVentures, alt: 'DigVentures' },
        { src: Verdane, alt: 'Verdane' },
        { src: Illusian, alt: 'Illusian' },
      ],
    ],
  ],
  compactNarrow: [
    [
      [
        { src: Miro, alt: 'Miro' },
        { src: Bolt, alt: 'Bolt' },
      ],
      [
        { src: Pleo, alt: 'Pleo' },
        { src: Truelayer, alt: 'TrueLayer' },
      ],
    ],
    [
      [
        { src: Webflow, alt: 'Webflow' },
        { src: Aiven, alt: 'Aiven' },
      ],
      [
        { src: Choco, alt: 'Choco' },
        { src: Superhuman, alt: 'Superhuman' },
      ],
    ],
  ],
  circle: [
    [
      [
        { src: PleoCompact, alt: 'Pleo' },
        { src: GoogleCloud, alt: 'GoogleCloud' },
        { src: GorgiasCompact, alt: 'Gorgias' },
      ],
      [
        { src: HoneycombCompact, alt: 'Honeycomb' },
        { src: Dotwork, alt: 'Dotwork' },
        { src: CapitalOne, alt: 'CapitalOne' },
      ],
    ],
  ],
} satisfies Record<string, Logos>

type Props = {
  title?: ReactNode
  hideBackground?: boolean
  variant?: keyof typeof logoSets
}

export function DarkLogoBlock(props: Props) {
  const {
    hideBackground = false,
    title = 'Swarmia powers modern software organizations from startups to enterprises',
    variant = 'all',
  } = props
  const logos: Logos = logoSets[variant]
  return (
    <Box
      backgroundColor={hideBackground ? undefined : 'black'}
      paddingTop={hideBackground ? 0 : 92}
      // @ts-expect-error -- this works
      paddingBottom={hideBackground ? 0 : 48 + overviewMinusMargin}
      position="relative"
      css={
        hideBackground
          ? ''
          : `
        background: linear-gradient(
          180deg,
          rgba(15, 14, 46, 0) 0%,
          #141318 20%
        );
      `
      }
    >
      <Box
        paddingX={hideBackground ? 0 : { xs: 20, md: 36 }}
        maxWidth="full"
        marginX="auto"
      >
        <Stack>
          <Box.h5
            color="white"
            textAlign="center"
            font="textLabel"
            lineHeight="130%"
            marginBottom={24}
          >
            {title}
          </Box.h5>
          {logos.map((group, i) => {
            return (
              <LogoRowGroup key={`group-${i}`}>
                {group.map((row, j) => {
                  return (
                    <Row space={8} overflow="hidden" key={`row-${j}`}>
                      {row.map(({ src, alt }) => {
                        return <Logo src={src} alt={alt} key={alt} />
                      })}
                    </Row>
                  )
                })}
              </LogoRowGroup>
            )
          })}
        </Stack>
      </Box>
    </Box>
  )
}

const LogoRowGroup = ({ children }: { children: ReactNode }) => {
  return (
    <Row
      space={8}
      flexWrap="wrap"
      justifyContent="center"
      marginTop={12}
      css={`
        img {
          max-width: 100%;
        }
      `}
    >
      {children}
    </Row>
  )
}

const Logo = ({ src, alt }: { src: string; alt: string }) => {
  return (
    <Box
      display="flex"
      flex={1}
      width={200}
      height={60}
      alignItems="center"
      justifyContent="center"
    >
      <img src={src} alt={alt} />
    </Box>
  )
}
